import { render, staticRenderFns } from "./DonateCard.vue?vue&type=template&id=37d289dc&scoped=true&"
import script from "./DonateCard.vue?vue&type=script&lang=js&"
export * from "./DonateCard.vue?vue&type=script&lang=js&"
import style0 from "./DonateCard.vue?vue&type=style&index=0&id=37d289dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d289dc",
  null
  
)

export default component.exports